import Layout from '@scripts/routes/Layout';
import App from '@scripts/app'
import gsap from 'gsap'
import { SplitText } from 'gsap/SplitText'

/**
 * Creates a new *Page*.
 *
 * *Page* is the default *Renderer*.
 *
 * Every other renderer should extend *Page* and implements its useful methods.
 *
 * @class
 * @augments Renderer
 */
export default class About extends Layout {

  onEnter() {
    super.onEnter()

    // App.cursor.toggleHide(true)

    this.init()
    // this.yoyo()
  }

  onEnterCompleted() {
    super.onEnterCompleted()
  }

  getElems() {
    super.getElems()

    this.circleMask = this.view.querySelector('.mask')
    this.surtitle = this.view.querySelector('.js-about-surtitle')
    this.txt = this.view.querySelector('.js-about-txt')
    this.links = this.view.querySelector('.js-about-links')
    this.pictures = this.view.querySelectorAll('.js-about-picture')
    this.panels = this.view.querySelectorAll('.js-about-panel')
    this.titles = this.view.querySelectorAll('.js-about-title')
  }

  events() {
    super.events()
  }

  pointermove(e) {
    super.pointermove(e)

    // this.moveX(e.clientX)
    // this.moveY(e.clientY)
  }

  init() {
    this.circleMask.setAttribute('cx', App.windowWidth / 2)
    this.circleMask.setAttribute('cy', App.windowHeight / 2)

    this.moveX = gsap.quickTo(this.circleMask, 'cx', { duration: 1, ease: 'expo.out' })
    this.moveY = gsap.quickTo(this.circleMask, 'cy', { duration: 1, ease: 'expo.out' })

    this.titles.forEach((item) => {
      item.split = new SplitText(item, { type: 'chars' })
      gsap.set(item.split.chars, { x: -80, filter: 'blur(18px)', opacity: 0, scale: 0.95 })
    })

    this.txt.split = new SplitText(this.txt, { type: 'lines' })
    new SplitText(this.txt, { type: 'lines' })

    gsap.set(this.txt.split.lines, { yPercent: 100 })
    gsap.set([this.links, this.surtitle], { opacity: 0 })
    gsap.set([this.pictures, this.panels], { clipPath: 'inset(0% 100% 0% 0%)' })
  }

  appear({ from, to, trigger, canvas } = {}) {
    const tl = gsap.timeline({
      delay: 1
    })

    tl.to(this.titles[0].split.chars, {
      duration: 1.35, x: 0, filter: 'blur(0px)', opacity: 1, scale: 1, stagger: {
        from: 'end', amount: 0.2
      }, ease: 'power2.out'
    }, 'start')

    tl.to(this.titles[1].split.chars, {
      duration: 1.35, x: 0, filter: 'blur(0px)', opacity: 1, scale: 1, stagger: {
        from: 'end', amount: 0.2
      }, ease: 'power2.out'
    }, 'start+=0.1')

    // tl.to(this.titles[0].split.chars, {
    //   duration: 0.7, x: 0, filter: 'blur(0px)', opacity: 1, stagger: {
    //     from: 'end', amount: 0.16
    //   }, ease: 'power2.out'
    // }, 'start')
    //
    // tl.to(this.titles[1].split.chars, {
    //   duration: 0.7, x: 0, filter: 'blur(0px)', opacity: 1, stagger: {
    //     from: 'end', amount: 0.16
    //   }, ease: 'power2.out'
    // }, 'start+=0.1')

    tl.to(this.panels, {
      duration: 1.35, clipPath: 'inset(0% 0% 0% 0%)', stagger: {
        from: 'rand', amount: 0.05
      }, ease: 'power2.out'
    }, 'start')

    tl.addLabel('step1', '-=0.25')

    tl.to(this.pictures, {
      duration: 1.2, clipPath: 'inset(0% 0% 0% 0%)', stagger: {
        from: 'random', amount: 0.2
      }, ease: 'expo.inOut'
    }, 'step1')

    tl.addLabel('step2', '-=0.85')

    tl.to(this.txt.split.lines, {
      duration: 1, yPercent: 0, stagger: {
        from: 'start', each: 0.07
      }, ease: 'power2.out'
    }, 'step2')

    tl.to([this.links, this.surtitle], {
      duration: 0.7, opacity: 1, ease: 'power2.inOut'
    }, 'step2')

    return tl
  }

  yoyo() {
    if (this.tlYoyo) this.tlYoyo.kill()

    this.tlYoyo = gsap.timeline({
      onComplete: this.yoyo.bind(this)
    })

    this.tlYoyo.to(this.circleMask, {
      r: 'random(100, 135)', duration: 1, ease: 'none'
    })
  }
}
